export default __webpack_public_path__ + "368cb78ac23380bd8bc0bc7179f828f9.svg";